module.exports = __webpack_public_path__ + "img/team-6.b65407e.webp";